if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;
      
//       custom ajax cart overalay
      $('#ajaxCartOverlay').removeClass('hidden');

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
          
//         	console.log('form submitted')
            updateMenuCart()
            sendEvent(this)
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

function updateMenuCart(){
const sectionID = document.getElementById('main-cart-items').dataset.id;
  var cartContents = fetch(`/?sections=${sectionID}`)
  .then(response => response.text())
  .then((data) => { 
	const parsedData = JSON.parse(data);
// 	console.log(parsedData[sectionID])
	let html = parsedData[sectionID]
//     console.log(html)
	let element_cart_item = document.getElementById('menuCart')
    let element_cart_price = document.getElementById('menuCartFooter')
	let itemData =  new DOMParser().parseFromString(html, 'text/html')
      .querySelector('#menuCart').innerHTML;    
	element_cart_item.innerHTML = itemData;
    let priceData = new DOMParser().parseFromString(html, 'text/html')
      .querySelector('#menuCartFooter').innerHTML;
	element_cart_price.innerHTML = priceData;
	 })
  .then(()=>{
    checkTimeSlot();
  	disableChckout();
    updateButtonState();
    $('#ajaxCartOverlay').addClass('hidden');
    removeSubscriptionInCart()
  })
}

function sendEvent(element){
// 	console.log(element)
    let modal = element.closest('.modal-content')
    modal.querySelector('.close').click()
//     let productName = modal.querySelector('.modal-title').innerText
//     let variantType = modal.querySelector('.cart-product__type > span:last-child').innerText
//     let variantName = modal.querySelector('[type=radio]:checked+label .variant-name').innerText
    let price = modal.querySelector('[type=radio]:checked+label .variant-price span').innerText
//     let store = modal.querySelector('input[name="properties[Store]"]').value
    price = parseInt(price.replace(/\D/g,''));
//   console.log('price', price)
//     console.log(variantType,variantName,price,store)
//     ga('send','event','Product Added','ATC '+store,productName+", "+variantType+"/"+variantName,price)
  gtag_report_conversion(undefined,price)
	
}